import type { CountryCode } from '~/core/i18n/types'
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode'

function formUrl(address: string | undefined) {
  return address ? `https://${address}` : ''
}

export const MT_APP_URL = {
  [COUNTRY_CODE.RU]: formUrl(process.env.applicationUrl),
  [COUNTRY_CODE.AM]: formUrl(process.env.applicationUrlAm),
  [COUNTRY_CODE.BY]: formUrl(process.env.applicationUrlBy),
  [COUNTRY_CODE.GE]: formUrl(process.env.applicationUrlGe),
  [COUNTRY_CODE.KG]: formUrl(process.env.applicationUrlKg),
  [COUNTRY_CODE.KZ]: formUrl(process.env.applicationUrlKz),
  [COUNTRY_CODE.MD]: formUrl(process.env.applicationUrlMd),
  [COUNTRY_CODE.TJ]: formUrl(process.env.applicationUrlTj),
  [COUNTRY_CODE.UZ]: formUrl(process.env.applicationUrlUz),
  [COUNTRY_CODE.other]: formUrl(process.env.applicationUrlOther),
} satisfies Record<CountryCode, string>

export const MT_INFO_URL = {
  [COUNTRY_CODE.RU]: formUrl(process.env.infoUrl),
  [COUNTRY_CODE.AM]: formUrl(process.env.infoUrlAm),
  [COUNTRY_CODE.BY]: formUrl(process.env.infoUrlBy),
  [COUNTRY_CODE.GE]: formUrl(process.env.infoUrlGe),
  [COUNTRY_CODE.KG]: formUrl(process.env.infoUrlKg),
  [COUNTRY_CODE.KZ]: formUrl(process.env.infoUrlKz),
  [COUNTRY_CODE.MD]: formUrl(process.env.infoUrlMd),
  [COUNTRY_CODE.TJ]: formUrl(process.env.infoUrlTj),
  [COUNTRY_CODE.UZ]: formUrl(process.env.infoUrlUz),
  [COUNTRY_CODE.other]: formUrl(process.env.infoUrlOther),
} satisfies Record<CountryCode, string>

export const MT_PROFILE_URL = {
  [COUNTRY_CODE.RU]: formUrl(process.env.profileUrl),
  [COUNTRY_CODE.AM]: formUrl(process.env.profileUrlAm),
  [COUNTRY_CODE.BY]: formUrl(process.env.profileUrlBy),
  [COUNTRY_CODE.GE]: formUrl(process.env.profileUrlGe),
  [COUNTRY_CODE.KG]: formUrl(process.env.profileUrlKg),
  [COUNTRY_CODE.KZ]: formUrl(process.env.profileUrlKz),
  [COUNTRY_CODE.MD]: formUrl(process.env.profileUrlMd),
  [COUNTRY_CODE.TJ]: formUrl(process.env.profileUrlTj),
  [COUNTRY_CODE.UZ]: formUrl(process.env.profileUrlUz),
  [COUNTRY_CODE.other]: formUrl(process.env.profileUrlOther),
} satisfies Record<CountryCode, string>

export const MT_LANDING_URL = {
  [COUNTRY_CODE.RU]: formUrl(process.env.landingUrl),
  [COUNTRY_CODE.AM]: formUrl(process.env.landingUrlAm),
  [COUNTRY_CODE.BY]: formUrl(process.env.landingUrlBy),
  [COUNTRY_CODE.GE]: formUrl(process.env.landingUrlGe),
  [COUNTRY_CODE.KG]: formUrl(process.env.landingUrlKg),
  [COUNTRY_CODE.KZ]: formUrl(process.env.landingUrlKz),
  [COUNTRY_CODE.MD]: formUrl(process.env.landingUrlMd),
  [COUNTRY_CODE.TJ]: formUrl(process.env.landingUrlTj),
  [COUNTRY_CODE.UZ]: formUrl(process.env.landingUrlUz),
  [COUNTRY_CODE.other]: formUrl(process.env.landingUrlOther),
} satisfies Record<CountryCode, string>

export const LOGO = {
  [COUNTRY_CODE.RU]: '/graphics/logo/medtochka.svg',
  [COUNTRY_CODE.AM]: '/graphics/logo/medtochka-am.svg',
  [COUNTRY_CODE.BY]: '/graphics/logo/medtochka-by.svg',
  [COUNTRY_CODE.GE]: '/graphics/logo/medtochka-ge.svg',
  [COUNTRY_CODE.KG]: '/graphics/logo/medtochka-kg.svg',
  [COUNTRY_CODE.KZ]: '/graphics/logo/medtochka-kz.svg',
  [COUNTRY_CODE.MD]: '/graphics/logo/medtochka-md.svg',
  [COUNTRY_CODE.TJ]: '/graphics/logo/medtochka-tj.svg',
  [COUNTRY_CODE.UZ]: '/graphics/logo/medtochka-uz.svg',
  [COUNTRY_CODE.other]: '/graphics/logo/medtochka.svg',
} satisfies Record<CountryCode, string>

export const LOGO_PD = {
  [COUNTRY_CODE.RU]: '/graphics/logo/prodoctorov.svg',
  [COUNTRY_CODE.AM]: '/graphics/logo/prodoctorov-am.svg',
  [COUNTRY_CODE.BY]: '/graphics/logo/prodoctorov-by.svg',
  [COUNTRY_CODE.GE]: '/graphics/logo/prodoctorov-ge.svg',
  [COUNTRY_CODE.KG]: '/graphics/logo/prodoctorov-kg.svg',
  [COUNTRY_CODE.KZ]: '/graphics/logo/prodoctorov-kz.svg',
  [COUNTRY_CODE.MD]: '/graphics/logo/prodoctorov-md.svg',
  [COUNTRY_CODE.TJ]: '/graphics/logo/prodoctorov-tj.svg',
  [COUNTRY_CODE.UZ]: '/graphics/logo/prodoctorov-uz.svg',
  [COUNTRY_CODE.other]: '/graphics/logo/prodoctorov.svg',
} satisfies Record<CountryCode, string>
